import { render } from "./index.vue?vue&type=template&id=63dba5ec&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=63dba5ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-63dba5ec"

export default script